import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { RoutingService } from '@rci/routing-service';
import { Observable } from 'rxjs';
import { Subnav } from '@rogers/cdk/assembled/subnav';
import { Link } from '@rogers/cdk/link';
import { secondaryNavAnalyticsConfig } from './secondary-nav-analytics-config';
import { ROUTES_REGEX, SecondaryNavService } from './secondary-nav.service';
import { SelfServeAnalyticsService } from '@rogers/self-serve-analytics';

const TRACK_EVENT_ROUTE_NAMES = ['orders', 'offers'];

@Component({
  selector: 'fss-secondary-nav',
  templateUrl: './secondary-nav.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class SecondaryNavComponent implements OnInit {
  secondaryNavData$: Observable<Subnav>;

  constructor(
    private readonly selfServeAnalyticsService: SelfServeAnalyticsService,
    private readonly router: Router,
    private readonly routingService: RoutingService,
    private readonly secondaryNavService: SecondaryNavService,
  ) {}

  get showSubNav() {
    return ROUTES_REGEX.test(this.router.url);
  }

  ngOnInit(): void {
    this.secondaryNavData$ = this.secondaryNavService.getSecondaryNavData$();
  }

  handleCtaClick(e: Link) {
    if (typeof e?.val === 'string') {
      this.trackEvent(e.val);
      this.routingService.navigate(e.val);
    }
  }

  private trackEvent(routeName: string) {
    if (routeName === 'promise-to-pay') {
      this.selfServeAnalyticsService.trackEvent(secondaryNavAnalyticsConfig.DropdownPromiseToPayCTAConfig);
    } else if (TRACK_EVENT_ROUTE_NAMES.includes(routeName) && !new RegExp(`^\/${routeName}`).test(this.router.url)) {
      this.selfServeAnalyticsService.trackEvent(secondaryNavAnalyticsConfig[routeName]);
    }
  }
}
